import { Program } from "../types/models/dms-contract";

export default function getProgramsWithLpuOnly (programs: Program[]): Program[] {
    return programs.filter(item => {
        return ['Амбулаторно-поликлиническая помощь', 'Стоматология'].includes(item.name.trim())
    })
}